import { Component } from '@angular/core';

import { AppLockService } from '../../services/app-lock.service';

@Component({
  selector: 'app-lock',
  templateUrl: './app-lock.component.html',
  styleUrls: ['./app-lock.component.scss'],
  standalone: false,
})
export class AppLockComponent {
  constructor(public appLockService: AppLockService) {}
}
